import React from 'react';
import type { AspectRatio } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

const ASPECT_RATIO_DIMENSIONS: Record<AspectRatio, string> = {
    landscape: '16:9',
    square: '1:1',
    vertical: '9:16',
    fourfive: '4:5',
};

const FormatOptionContent: React.FC<{ aspectRatio: AspectRatio }> = ({ aspectRatio }) => (
    <span>
        {VideoData.getAspectRatioDisplayName(aspectRatio)} ({ASPECT_RATIO_DIMENSIONS[aspectRatio]})
    </span>
);

export const buildFormatDropdownItems = <T extends object>(
    buildOnSelectData: (aspectRatio: AspectRatio) => T,
    availableAspectRatios: AspectRatio[],
    activeAspectRatio?: AspectRatio | null,
) => {
    return availableAspectRatios.map((aspectRatio) => {
        const isActive = activeAspectRatio != null && aspectRatio === activeAspectRatio;
        return {
            id: `format-${aspectRatio}`,
            text: '',
            active: isActive || undefined,
            onSelectData: buildOnSelectData(aspectRatio),
            children: <FormatOptionContent aspectRatio={aspectRatio} />,
        };
    });
};
